import React from "react";
import { Authenticator } from "aws-amplify-react";
import { IntlProvider } from "react-intl";
import AuthWrapper from "../AuthWrapper";
import { GlobalContextConsumer, GlobalContextProvider } from "../../context.global";
import locales from "../../locales";
import "./styles.css";

class App extends React.Component {
  render() {
    return (
      <GlobalContextProvider>
        <GlobalContextConsumer>
          {(context) => (
            <IntlProvider locale={context.locale} messages={locales[context.locale]}>
              <div className="App">
                <Authenticator hideDefault={true}>
                  <AuthWrapper />
                </Authenticator>
              </div>
            </IntlProvider>
          )}
        </GlobalContextConsumer>
      </GlobalContextProvider>
    );
  }
}

export default App;
